








import VueOptions from '@utils/VueOptions'
import OrganizerShow from '@hostComponents/Team/Organizer/OrganizerShow'

settings = 
  name: ""
  components: { OrganizerShow }

export default VueOptions.vue settings
